import { localVariables } from '@/utils/constants';
import apiClient from '../client';
const ENDPOINT = '/user';

export const usersApi = {
    getList: () => apiClient.get(ENDPOINT),
    getDetail: (id) => apiClient.get(`${ENDPOINT}/${id}`),
    create: (payload) => apiClient.post(ENDPOINT, payload),
    update: (payload) => apiClient.put(`${ENDPOINT}/${payload.id}`, payload),
    delete: (payload) => apiClient.delete(`${ENDPOINT}/${payload.id}`, payload),
    getUserProfile: () => apiClient.get(`${ENDPOINT}/profile`),
    updateUserProfile: (payload) => apiClient.put(`${ENDPOINT}/profile`, payload),
    saveProfileData: ({ user }) => {
        localStorage.setItem(localVariables.USER, JSON.stringify(user));
    },
    clearProfileData: () => {
        localStorage.removeItem(localVariables.USER);
    }
};
